import { useState, useEffect } from 'react'
import axios from 'axios'

const isClient = typeof window === 'object'

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(() => ({ width: window.innerWidth, height: window.innerHeight }))

  useEffect(() => {
    const onResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  })

  return windowSize
}

// Utils
export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      return () => {
        clearTimeout(handler)
      }
    },

    [value] 
  );

  return debouncedValue
}

export const useArray = initialArray => {
  const [array, set] = useState(initialArray)

  return [array, {
    set,
    push: x => set([...array, x]),
    unshift: x => set([x, ...array]),
    filter: fn => set(array.filter(fn)),
    find: fn => set(array.find(fn)),
    map: fn => set(array.map(fn)),
    sort: fn => set([...array].sort(fn)),
  }]
}

// Location
export const useBrowserLocation = ({ round = false }) => {
  if (!isClient) {
    return { latitude: 0, longitude: 0, accuracy: 'Unknown - Location not allowed'}
  }

  const [location, setLocation] = useState({ latitude: 0, longitude: 0, accuracy: 'Getting location...'})
  const roundLocation = (coordinates, round) => {
    return {
      latitude: round ? Math.round(coordinates.latitude) : coordinates.latitude,
      longitude: round ? Math.round(coordinates.longitude) : coordinates.longitude,
      accuracy: coordinates.accuracy,
    }
  }

  useEffect(() => {
    try {
      navigator.geolocation.getCurrentPosition(location => {
        return setLocation(roundLocation(location.coords, round))
      })
    } catch {
      setLocation({ latitude: 0, longitude: 0, accuracy: 'Unknown - Location not found'})
    }
  })

  return location
}
